import axios from 'axios';
import toCamelCase from '../utils/camelCase';
import { mergeRules } from '../utils/compatibilityRules';
import {
  API_ENDPOINT_SHIPPING_OPTIONS,
  API_ENDPOINT_PRICE,
  API_ENDPOINT_ESTIMATE_DELIVERY_SO,
  API_ENDPOINT_EXECUTE_RULES,
  recordApiResponse,
  COPY_LOGO,
  ADD_PREV_LOGO_TO_NEWLINEITEM_API,
  CREATE_LIQUIDPIXEL_UPDATED_LOGO,
} from '../utils/newRelic';
import getExpConfig from '../utils/getExpConfig';

export const getShippingOptions = (itemId, zipCode) => {
  const url = `${getExpConfig('eleanor-base-url')}/api/shipping/GetDeliveryOptions`;

  const params = { itemId, zipCode };

  const promise = axios.get(url, { params });

  return recordApiResponse(promise, API_ENDPOINT_SHIPPING_OPTIONS, url, params).then(
    (response) => response.data
  );
};

export const getMsrpPricingFromAutobahn = (params) => {
  const url = `${getExpConfig('eleanor-base-url')}/api/pricing/product`;

  const promise = axios.post(url, params);

  return recordApiResponse(promise, API_ENDPOINT_PRICE, url, params).then((response) =>
    toCamelCase(response.data)
  );
};

export const getSpecialOrderDeliveryTime = (siteId, partnerProductId) => {
  const url = `${getExpConfig('eleanor-base-url')}/api/shipping/estimatedelivery/specialorder`;

  const params = { siteId, partnerProductId };

  const promise = axios.post(url, params);

  return recordApiResponse(promise, API_ENDPOINT_ESTIMATE_DELIVERY_SO, url, params).then(
    (response) => toCamelCase(response.data)
  );
};

export const executeRules = (selectionData) => {
  const route = 'ExecuteRulesViaPost';
  const url = `${getExpConfig('eleanor-base-url')}/catalog/productconfiguration/${route}`;

  const promise = axios({
    data: selectionData,
    url,
    method: 'POST',
    crossDomain: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return recordApiResponse(promise, API_ENDPOINT_EXECUTE_RULES, url, selectionData).then(
    toCamelCase
  ); // intentional. for use by configurator
};

export const executeAllRules = (selectionData) => {
  const url = {
    base: `${getExpConfig('eleanor-base-url')}/catalog/productconfiguration`,
    productRulesEndpoint: 'ExecuteRulesViaPost',
    compatibilityRulesEndpoint: 'ExecuteCompatibilityRulesViaPost',
  };

  const promiseProductRules = axios({
    data: selectionData,
    url: `${url.base}/${url.productRulesEndpoint}`,
    method: 'POST',
    crossDomain: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const promiseCompatibilityRules = axios({
    data: selectionData,
    url: `${url.base}/${url.compatibilityRulesEndpoint}`,
    method: 'POST',
    crossDomain: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const mergedPromises = Promise.all([promiseProductRules, promiseCompatibilityRules]);

  return recordApiResponse(mergedPromises, API_ENDPOINT_EXECUTE_RULES, url, selectionData).then(
    mergeRules
  );
};

export const copyLogoApi = (params) => {
  const url = `${getExpConfig('eleanor-base-url')}/api/copylogo`;

  const promise = axios.post(url, params);

  return recordApiResponse(promise, COPY_LOGO, url, params).then((response) =>
    toCamelCase(response.data)
  );
};

export const addPrevLogoToNewLineItemApi = (params) => {
  const url = `${getExpConfig('eleanor-base-url')}/api/copynewlineitemlogo`;
  const promise = axios.post(url, params);

  return recordApiResponse(promise, ADD_PREV_LOGO_TO_NEWLINEITEM_API, url, params).then((response) =>
    toCamelCase(response.data)
  );
};
export const updateLiquidPixelLogoToS3Api = (params) => {
  const url = `${getExpConfig('eleanor-base-url')}/api/addliquidpixelimage`;
  const promise = axios.post(url, params);

  return recordApiResponse(promise, CREATE_LIQUIDPIXEL_UPDATED_LOGO, url, params).then((response) =>
    toCamelCase(response.data)
  );
};
